import { createAction, handleActions } from 'redux-actions';
import ActionTypes from '../../constants/actionTypes';

// const collapsed = false;
const initialState = {
  collapsed: false,
  toggled: false,
};

export const updateSidebarToggle = createAction(ActionTypes.UPDATE_TOGGLE_STATE, (toggled) => toggled);
export const updateSidebarCollapse = createAction(ActionTypes.UPDATE_COLLAPSED_STATE, (collapsed) => collapsed);

export default handleActions({
  [ActionTypes.UPDATE_TOGGLE_STATE]: (state, action) => ({ ...state, toggled: action.payload }),
  [ActionTypes.UPDATE_COLLAPSED_STATE]: (state, action) => ({ ...state, collapsed: action.payload }),
}, initialState);
